if(!customElements.get('anchor-button')) {
  class ComponentAnchorButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.anchorId = this.dataset.anchorId;

      this.button.addEventListener('click', ()=> {
        var target = document.getElementById(this.anchorId);

        if(target)
          $s.scrollToElement(target);
      })
    }

    

  }
  customElements.define('anchor-button', ComponentAnchorButton);
}